//TS reflection of StateInfo.cs.States
enum States
{
	blank,
	Alabama, //1
	Alaska,
	Arizona,
	Arkansas,
	California, //5
	Colorado,
	Connecticut,
	Delaware,
	Florida,
	Georgia, //10
	Hawaii,
	Idaho,
	Illinois,
	Indiana,
	Iowa, //15
	Kansas,
	Kentucky,
	Louisiana,
	Maine,
	Maryland, //20
	Massachusetts,
	Michigan,
	Minnesota,
	Mississippi,
	Missouri, //25
	Montana,
	Nebraska,
	Nevada,
	NewHampshire,
	NewJersey, //30
	NewMexico,
	NewYork,
	NorthCarolina,
	NorthDakota,
	Ohio, //35
	Oklahoma,
	Oregon,
	Pennsylvania,
	PuertoRico, //39 Numbering gets off here
	RhodeIsland,//40
	SouthCarolina,
	SouthDakota,
	Tennessee,
	Texas,
	Utah, //45
	Vermont,
	Virginia,
	Washington,
	WashingtonDC,//49 Watch out for this
	WestVirginia, //50
	Wisconsin, //51
  Wyoming, //52
  VirginIslands
}